import CommitteeSliderInMainPage from "./CommitteeSliderInMainPage";
import CommitteeDescriptionInMainPage from "./CommitteeDescriptionInMainPage";
import MissionBanner from "./MissionBanner";
import ContentSection from "./ContentSection";
import DownloadSection from "./DownloadSection";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { homePageActions } from "../../../_store/home.slice";
import CalenderInMainPage from "./BCSPCalender";

function LandingPage() {
  const dispatch = useDispatch();

  useEffect(() => {
    getHomePageContent();
  }, []);

  const getHomePageContent = () => {
    dispatch(homePageActions?.homePageContent());
  };

  return (
    <div className="landing-page">
      <div className="mobile-view-text d-block d-sm-none text-center bg-warning p-2">
        This page is best viewed in landscape/horizontal view
      </div>
      <MissionBanner />
      <CommitteeDescriptionInMainPage />
      <CommitteeSliderInMainPage />
      <CalenderInMainPage />
      <ContentSection />
      <DownloadSection />
    </div>
  );
}

export default LandingPage;
